import cookie from "js-cookie";

const get = (key) => {
    return cookie.get(key)
}

const set = (key, value) => {
    cookie.set(key, value)
}

export default {
    get,
    set
}